import { sampleClips } from "./sampleData.js";
export function getBabySample(staticAssetBaseUrls, themeId = "paint-daubs", themeVersion) {
    return {
        version: 1,
        occasionId: "baby",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Welcome to the world, little one! 🌟",
                "We can't wait to watch you grow and learn.",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: ["Congratulations on your new arrival! 🌟"],
        },
        faceCollageEnabled: true,
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "a-minor-waltz",
                name: "A Minor Waltz",
                duration: 140.329796,
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/A_Minor_Waltz.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
        userInput: {
            title1: "Congrats!",
            title2: "So Exciting!",
        },
    };
}
